module.exports = __webpack_public_path__ + "img/loading.1d8cdbd2.svg";